export default __webpack_public_path__ + "static/img/homepage-selection-fg.060a723.png";